module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h1', [_vm._v("群星金融发展历程")]), _vm._v(" "), _c('div', {
    staticClass: "swiper"
  }, [_c('span', {
    staticClass: "left-arrow",
    on: {
      "click": function($event) {
        _vm.slidRight = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-cover"
  }, [_c('ul', {
    class: _vm.slidRight ? 'slidRight' : ''
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])]), _vm._v(" "), _c('span', {
    staticClass: "right-arrow",
    on: {
      "click": function($event) {
        _vm.slidRight = true
      }
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("荣誉奖项")]), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }, [_c('el-carousel', {
    attrs: {
      "loop": false,
      "interval": 0,
      "arrow": "always",
      "type": "card",
      "height": "430px",
      "indicator-position": "none"
    }
  }, [_c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "67px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup08@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年04月")]), _vm._v(" "), _c('h2', [_vm._v("首届中国商业保理行业创新奖")]), _vm._v(" "), _c('h3', [_vm._v("中国服务贸易协会商业保理专业委员会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "86px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup07@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年11月")]), _vm._v(" "), _c('h2', [_vm._v("2016德勤-华兴中国明日之星")]), _vm._v(" "), _c('h3', [_vm._v("德勤中国、华兴资本颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "149px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup06@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年11月")]), _vm._v(" "), _c('h2', [_vm._v("第一财经金融价值榜"), _c('br'), _vm._v("“最佳平台科技金融公司”")]), _vm._v(" "), _c('h3', [_vm._v("第一财经颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "141px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup05@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2016年12月")]), _vm._v(" "), _c('h2', [_vm._v("2016创业黑马TOP100"), _c('br'), _vm._v("“中国最具潜力创业公司”")]), _vm._v(" "), _c('h3', [_vm._v("创业黑马颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "52px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup04@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年03月")]), _vm._v(" "), _c('h2', [_vm._v("2016年度十佳新零售服务商")]), _vm._v(" "), _c('h3', [_vm._v("联商网颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup03@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年06月")]), _vm._v(" "), _c('h2', [_vm._v("十佳互联网金融创新奖")]), _vm._v(" "), _c('h3', [_vm._v("《银行家》颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "124px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup02@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年07月")]), _vm._v(" "), _c('h2', [_vm._v("2017最具成长价值奖")]), _vm._v(" "), _c('h3', [_vm._v("第六届中国财经峰会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "246px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup01@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2017年09月")]), _vm._v(" "), _c('h2', [_vm._v("金惠奖·普惠金融优秀解决方案")]), _vm._v(" "), _c('h3', [_vm._v("中国普惠金融大会颁发")])]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    staticStyle: {
      "width": "136px"
    },
    attrs: {
      "src": "/imgs/portal/about/cup09.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("2018年03月")]), _vm._v(" "), _c('h2', [_vm._v("年度金融科技介甫奖")]), _vm._v(" "), _c('h3', [_vm._v("—最具影响力供应链金融服务机构")])])], 1)], 1), _vm._v(" "), _c('h1', [_vm._v("企业文化")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('news')
      }
    }
  }, [_vm._v("了解更多")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.topage('join')
      }
    }
  }, [_vm._v("加入我们")])])]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("\n        公司介绍\n        "), _c('span', [_vm._v("什么是供应链金融\n          "), _c('div', {
    staticClass: "dialog"
  }, [_c('h3', [_vm._v("什么是供应链金融？")]), _vm._v(" "), _c('p', [_vm._v("通过银行将核心企业和上下游企业联系在一起，把单个企业的不可控风险转变为供应链企业整体的可控风险，通过立体获取各类信息，将风险控制在最低的金融服务。简单地说，就是提供灵活运用的金融产品和服务的一种融资模式,即把资金作为供应链的一个溶剂，增加其流动性。")])])])]), _vm._v(" "), _c('h2', [_vm._v("一家专注于供应链金融长尾的互联网交易平台")]), _vm._v(" "), _c('h3', [_vm._v("群星金融成立于2013年6月，六年来一直专注于供应链金融长尾市场。"), _c('br'), _vm._v("群星金融以技术为第一驱动力，通过互联网技术与大数据风控，"), _c('br'), _vm._v("让沉积于中小企业的应收账款获得流动性，全面降低中小企业融资成本的同时，"), _c('br'), _vm._v("为参与交易的核心企业，金融机构等多方主体创造价值。")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/moneyflow@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让核心企业的经营性现金流发挥最大效率的作用")]), _vm._v(" "), _c('aside')]), _vm._v(" "), _c('div', {
    staticClass: "info rongzi"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/rongzi@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让中小供应商享受货款现结解决融资难的问题")]), _vm._v(" "), _c('aside')]), _vm._v(" "), _c('div', {
    staticClass: "info index"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/index@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v("让银行享受优质企业资源批量解决支小指标")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2013年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.6@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/6")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("群星金融网"), _c('br'), _vm._v("成立并上线")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.10@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/10")]), _vm._v(" "), _c('span', [_vm._v("与交通银行浙江省分行就中小企业产业链融资签署战略协议，推出产品\"E贷链\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "big"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2013.11@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2013/11")]), _vm._v(" "), _c('span', [_vm._v("与联想集团、物美集团签署合作协议")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("2014年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#0c70b6"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2014.8@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2014/8")]), _vm._v(" "), _c('span', [_vm._v("获得北极光创投领投，华创资本跟投的500万美元A轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "big",
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "76px"
    },
    attrs: {
      "src": "/imgs/portal/about/2014.9@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2014/9")]), _vm._v(" "), _c('span', [_vm._v("海尔日日顺项目上线放款")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("2015年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#478afd"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2015.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2015/4")]), _vm._v(" "), _c('span', [_vm._v("获得由华创、IDG的2000万美元B轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2016年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "20px auto 10px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/4")]), _vm._v(" "), _c('span', [_vm._v("获得商业保理专业委员会颁发的\"创新奖\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.5@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/5")]), _vm._v(" "), _c('span', [_vm._v("获得由曦域资本领投，深圳前海母基金跟投的1.5亿元B+轮融资")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#0c70b6"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.7@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/7")]), _vm._v(" "), _c('span', [_vm._v("累计提供融资突破100亿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#1f5dea"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/11")]), _vm._v(" "), _c('span', [_vm._v("荣获\"2016德勤-华兴中国明日之星\"、第一财经金融价值榜\"最佳平台科技金融公司\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "32px",
      "width": "50px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.12@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2016/12")]), _vm._v(" "), _c('span', [_vm._v("\"虚拟财务公司\"产品发布，同期荣获\"创业黑马TOP100-中国最具潜力创业公司\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2017年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "23px auto 10px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/3")]), _vm._v(" "), _c('span', [_vm._v("获联商网\"2016年度新零售十佳服务商\"")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#709df2"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "89px",
      "margin": "65px auto 43px"
    },
    attrs: {
      "src": "/imgs/portal/about/2017.6@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/6")]), _vm._v(" "), _c('span', [_vm._v("荣获《银行家》\"十佳互联网金融创新奖\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "background": "#3b9ce0"
    }
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("2017/7")]), _vm._v(" "), _c('span', [_vm._v("获第六届中国财经峰会\"2017最具成长价值讲\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "small"
  }, [_vm._v("2018年")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('img', {
    staticStyle: {
      "margin": "20px auto 8px"
    },
    attrs: {
      "src": "/imgs/portal/about/2016.4@2x.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_vm._v("2018/3")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("年度金融科技介甫奖—最具影响力供应链金融服务机构")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "life"
  }, [_c('span', [_c('div', [_vm._v("我们的圣诞派对"), _c('br'), _vm._v("派发圣诞礼物")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的群星漫画集"), _c('br'), _vm._v("“群小星来啦”")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的季度总结大会"), _c('br'), _vm._v("CEO演讲")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的户外旅途"), _c('br'), _vm._v("三清山之旅")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的周年庆典"), _c('br'), _vm._v("活动庆典")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的公司内刊"), _c('br'), _vm._v("星迹杂志")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的群星峰会"), _c('br'), _vm._v("活动现场")])]), _vm._v(" "), _c('span', [_c('div', [_vm._v("我们的业余生活"), _c('br'), _vm._v("群星电竞比赛")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-230a511e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/About.vue
// module id = 1283
// module chunks = 26